<template>
  <div>
    <v-toolbar flat color="blue-grey--text lighten-2">
     <v-toolbar-title>
     </v-toolbar-title>
     <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout row>
      <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
        <v-data-table
        :headers="headers"
        :items="getSearchResults"
        class="elevation-1"
        :total-items=this.maxRows
        :hide-actions=this.hideActions
        >
         <template slot="items" slot-scope="props">
           <td class="text-xs-left">
             <!-- ID  -->
             {{ defineID(props.item.basic.idg) }}
           </td>
           <!-- TITLE -->
           <td class="text-xs-left">
             {{ props.item.basic.title }}
          </td>
          <!-- Email -->
          <td class="text-xs-left">
            {{ props.item.char.epri}}
         </td>
          <td class="text-xs-left">
            <!-- ACTIVE -->
            <div v-if="props.item.basic.act === true">
              Active
            </div>
            <div v-else>
              Not Active
            </div>
          </td>
          <!-- LICENCE -->
          <td class="text-xs-left">
            {{ props.item.basic.rlic}}
          </td>
          <td class="text-xs-right">
           <v-layout row>
             <v-spacer/>
             <AdminUserInfoCard :data="props.item"/>
           </v-layout>
          </td>
         </template>
       </v-data-table>
       <v-layout class="mb-4">
         <v-spacer/>
         <div v-if="btnSpinLoadMore === false">
           <v-btn
           @click="loadNext()"
           :color="ui.colorBlue"
           flat dark>
             <v-icon left :color="ui.colorBlue"> cloud </v-icon>
               load more
           </v-btn>
         </div>
         <div v-else>
           <BtnSpin dark :btnSpec="btnInfo1"/>
         </div>
       </v-layout>
       <v-layout class="mb-4"/>
       <v-layout class="mb-2"/>
       <!-- <AssetNotificationsSearchOptionsBar/> -->
     </v-flex>
    </v-layout>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import AdminUserInfoCard from "@/admin/admin/components/AdminUserInfoCard";

export default {
  components: {
    BtnSpin,
    AdminUserInfoCard
    // RegisterSelect
  },
  mixins: [dateFunctions, numberFunctions, apptheme, getList],
  data() {
    return {
      maxRows: -1,
      btnSpinLoadMore: false,
      hideActions: true,
      barMovement: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    }
  },
  computed: {
    ...mapGetters(["getSearchResults"]),
    headers() {
      let table = [
        { text: "ID", sortable: false },
        { text: "Name", sortable: false },
        { text: "Email", sortable: false },
        { text: "Active", sortable: false },
        { text: "Licence", sortable: false },
        { text: "", sortable: false, align: "right" }
      ];
      return table;
    }
  }
};
</script>
